import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "../../../components/Icon";
import HeroScrollIcon from "../../../icons/hero-scroll.svg";
export const HeroScrollBlock = () => {
    return _jsx(Icon, { component: HeroScrollIcon });
};
//# sourceMappingURL=HeroScrollBlock.js.map